import { gql } from '@apollo/client';

export const GET_ORDER_CUSTOMER_COMPANY_NAME = gql`
    query GetOrderCustomerCompanyNameByTrackingNumber($trackingNumber: String!) {
        getOrderCustomerCompanyNameByTrackingNumber(trackingNumber: $trackingNumber)
    }
`;

export interface GetOrderCustomerCompanyNameResponse {
    getOrderCustomerCompanyNameByTrackingNumber: string;
}

export interface GetOrderCustomerCompanyNameVariables {
    trackingNumber: string;
}